define.alias("shared/utils/object-methods/stack-object-array-values", "settings/utils/object-methods/stack-object-array-values");